import { createClient } from '@app/http-client';
import { store } from '../store';
import config from '../config';

const apiClient = createClient({
  baseURL: config.physioBaseUrl,
  withCredentials: true,
  getAuthToken: () => store.getState().user.authToken,
  getEntityId: () => store.getState().app?.config?.entityId,
});

export default apiClient;
